import {makeAutoObservable} from 'mobx';
import {AuditLogsResponse} from '../../entity/resource/audit-logs-response';
import {TitleAuditLogsResponse} from '../../entity/resource/title-audit-logs-response';
import {AuditLogsAgent} from '../agent/audit-logs-agent';

export default class AuditLogsStore {
  auditLogsAgent: AuditLogsAgent;

  constructor(auditLogsAgent: AuditLogsAgent) {
    makeAutoObservable(this);
    this.auditLogsAgent = auditLogsAgent;
  }

  getAuditLogs = async (organizationId: string, batchId: string): Promise<AuditLogsResponse[] | string> => {
    try {
      return await this.auditLogsAgent.getAuditLogs(organizationId, batchId);
    } catch (error: any) {
      console.error('Error occurred while get title logs. Please try again in while !!', error);
      return 'Error occurred while get title logs. Please try again in while !!';
    }
  }

  getTitleAuditLogs = async (organizationId: string, titleId: string, titleStatus?: string): Promise<TitleAuditLogsResponse[] | string> => {
    try {
      if (titleStatus === 'COMPLETED')
        return await this.auditLogsAgent.getTitleAuditLogsFromS3(organizationId, titleId);

      return await this.auditLogsAgent.getTitleAuditLogs(organizationId, titleId);
    } catch (error: any) {
      console.error('Error occurred while getting title audit logs. Please try again in a while !!', error);
      return 'Error occurred while getting title audit logs. Please try again in a while !!';
    }
  }
}
